import { useMutation, useQueryClient } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { userKey } from 'api/hooks/useUser';

interface Props {
  blueLang: string;
  greenLang: string;
  blueCurrency: {
    code: string;
  };
  greenCurrency: {
    code: string;
  };
}

const profileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['profileMutation'],
    mutationFn: (body: Props) => agent.getClient(false).patch('/auth/me', body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKey });
    },
  });
};

export default profileMutation;
